export default "__VITE_ASSET__yf4BGpfg__"